import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/auth/hooks/useAuth';
import { BetaAccessForm, BetaAccessThankYou } from '../components';
import { useBetaAccessSubmit } from '../hooks';

export function BetaAccessPublicPage() {
  const { submit, isSubmitting, isSuccess, error } = useBetaAccessSubmit();
  const { user } = useAuth();
  const isAdmin = useMemo(() => user?.roles?.includes('admin') ?? false, [user?.roles]);

  if (isSuccess) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center p-4">
        <BetaAccessThankYou />
      </div>
    );
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-4">
      <div className="w-full max-w-lg space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">Join the Fias Beta</h1>
          <p className="text-muted-foreground">
            Fias is currently in closed beta. Submit your request below and our team will review
            your application. If accepted, you will receive an invite code via email.
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Request Access</CardTitle>
          </CardHeader>
          <CardContent>
            {error && (
              <div className="mb-4 p-3 rounded-md bg-destructive/10 text-destructive text-sm">
                {error}
              </div>
            )}
            <BetaAccessForm onSubmit={submit} isSubmitting={isSubmitting} />
          </CardContent>
        </Card>

        {isAdmin && (
          <div className="flex justify-center">
            <Button variant="outline" size="sm" asChild>
              <Link to="/a/arche_beta_access/admin">
                <Shield className="mr-2 h-4 w-4" />
                Admin Dashboard
              </Link>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
